<template>
  <div v-if="!$q.screen.gt.xs" class="action-buttons z-index-1 col column justify-end full-height full-width bg-white">
    <div class="action-buttons__content row justify-evenly items-center">
      <CancelButton v-close-popup class="action-button" :class="{ 'full-width': actionButtonText }" label="Close" />
      <q-btn
        v-if="actionButtonText"
        class="action-button"
        color="white"
        :disable="disableActionButton"
        :label="actionButtonText"
        :loading="loading"
        square
        text-color="primary"
        @click="$emit('click')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ actionButtonText?: string; disableActionButton?: boolean; loading?: boolean }>();
defineEmits(['click']);
</script>

<style scoped lang="scss">
.action-buttons {
  position: sticky;
  bottom: 0;
}

.action-buttons__content {
  border-top: 1px solid $grey-4;
  padding: 16px 16px calc(16px + var(--safe-area-bottom));
}
</style>
